











import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
    props: [
        "value"
    ],
    setup(props, context) {
        const dialog = computed({
            get() {
                return props.value
            },
            set(newValue) {
                context.emit('input', newValue);            }
        })
        return {
            dialog
        }
    }
});
